var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('header-top-logo'),_c('div',{staticClass:"spacer"}),(!_vm.isFocalPoint)?_c('NotificationMenu'):_vm._e(),_c('HeaderTopUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }